import ImgJiraPrincipal from "Contents/JiraTracking/imgs/principal.jpg";
import ImgJiraLogo from "Contents/JiraTracking/imgs/logo.png";
import ImgTablero from "Contents/JiraTracking/imgs/tablero.jpg";
import ImgStop from "Contents/JiraTracking/imgs/stopTracking.jpg";
import ImgTrackerIniciar from "Contents/JiraTracking/imgs/trackerIniciar.jpg";
import ImgIniciar from "Contents/JiraTracking/imgs/iniciar.jpg";
import { CarouselItemProps } from "Componentes/CarouselFede/CarouselItem";

const InfoList: Array<CarouselItemProps> = [
  {
    titulo: "Guia de trackeo en Jira",
    description:
      "Bienvenidos a la guía para aprender a hacer un buen trackeo en Jira",
    image: ImgJiraLogo,
    column: true
  },
  {
    titulo: "Acceder a un tablero",
    description:
      "Desde la página principal de Jira usando el buscador, los proyectos recientes o la lista de proyectos acceder a un tablero de trabajo",
    image: ImgJiraPrincipal
  },
  {
    titulo: "Acceder a una actividad",
    description:
      'Abrir o crear la actividad con la que va a trabajar haciendo click en la misma o en el botón crear del menú superior de Jira (si va a empezar a trabajarla esta debería ubicarse en la columna "in progress")',
    image: ImgTablero
  },
  {
    titulo: "Hourglass Time Tracker",
    description:
      'Desde una actividad hacer click en la opción de Hourglass Time Tracker: "Start Tracking Time" en la que puedes inicar el trackeo y finalizar una vez que hayas terminado la actividad o dejes de trabajarla por el momento',
    image: ImgTrackerIniciar
  },
  {
    titulo: "Iniciar trackeo",
    description:
      "Dentro del menú de Hourglass Time Tracker se puede iniciar el trackeo activando el contador de tiempo",
    image: ImgIniciar,
    column: true
  },
  {
    titulo: "Detener el contador",
    description:
      "Una vez finalizada o pausada la actividad accerder nuevamente a Hourglass Time Tracker y parar el contador, con la posibilidad de editar la cantidad de tiempo que pasó y/o la hora a la que comenzó el proceso en caso de que sea necesario y tambien agregar un texto que detalle que trabajo se realizó en ese periodo de tiempo",
    image: ImgStop
  }
];

export default InfoList;
